exports = module.exports = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-5a4044fd] .dialog-box .el-dialog__body{max-height:550px;overflow-y:auto}", ""]);

// exports
